<template>
  <section class="selectUser container">
    <h1 class="title">
      {{ $t('perfil.selecionar-perfil') }}
    </h1>
    <transition name="card-fade">
      <div v-show="perfis" class="selectCards">
        <div
          class="userCard"
          v-for="perfil in perfis"
          :key="perfil.CodigoPessoa"
        >
          <div class="image" @click="selecionarPerfil(perfil.CodigoPessoa)">
            <img
              :src="require(`../../assets/images/avatars/${perfil.Avatar}.svg`)"
              alt="avatar"
            />
          </div>
          <h2 class="label">
            {{ perfil.Nome }}
          </h2>
        </div>
      </div>
    </transition>
    <b-loading :is-full-page="true" :active.sync="isLoading" />
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { SET_LOADING } from '@/store/modules/mutation-types'
import router from '@/router'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  name: 'SelecionarPerfil',
  computed: {
    ...mapGetters({
      perfis: 'perfis',
      paciente: 'dadosPaciente',
      isLoading: 'loadingAuth'
    })
  },
  methods: {
    ...mapActions(['getPaciente']),
    ...mapMutations([SET_LOADING]),
    selecionarPerfil(codigoUsuario) {
      this.SET_LOADING(true)
      this.getPaciente(codigoUsuario)
        .then(() => {
          this.SET_LOADING(false)
          if (this.paciente != null) {
            let url = '/inicio'
            if (this.$route.query.returnUrl) {
              url = this.$route.query.returnUrl
            }
            this.$router.push(url)
          }
        })
        .catch((err) => {
          this.SET_LOADING(false)
          if (err instanceof NotAuthenticatedError) router.push('/')
        })
    }
  },
  beforeMount: function () {
    if (this.perfis.length < 1) {
      router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.card-fade-enter,
.card-fade-leave-active {
  opacity: 0;
}
.card-fade-enter-active,
.card-fade-leave-active {
  transition: opacity 0.3s ease;
}
.app-view {
  padding-bottom: 5rem;
}
.selectUser {
  margin: 2rem auto;
  padding-top: 10rem;
  .title {
    text-align: center;
  }
  .selectCards {
    margin-top: 5rem;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .userCard {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: 0 2rem;
      .image {
        height: 6.6875rem;
        width: 6.6875rem;
        border: 0.125rem solid $white;
        border-color: var(--white);
        border-radius: 50%;
        background-color: rgba(0, 159, 227, 0.23);
        overflow: hidden;
        position: relative;

        img {
          position: absolute;
          bottom: 0;
          width: 100%;
        }
        &:hover {
          cursor: pointer;
          border: 0.125rem solid rgba(0, 159, 227, 0.23);
        }
      }
      .label {
        text-align: center;
        margin-top: 0.25rem;
      }
    }
  }
}
</style>
